module.exports = __webpack_public_path__ + "static/media/img-moduleB5.431d4632.png";